+function($, document) {
	var scope;
	
	var ResendConfirmation = function(element, options) {
		this.$element = $(element);
		this.$body = $(document.body);
		this.options = options;
		
		this.initialize();
	};
	
	ResendConfirmation.DEFAULTS = {
		successMsg: 'Email confirmation is sent again. Please check your email box!'
	};
	
	ResendConfirmation.prototype.initialize = function() {
		scope = this;
		
		this.$element.on('click', function() {
			$.publish('showajaxnotification.sn');
			
			var deffered = $.post('/customer/resend_confirmation'),
				alertEl = scope.$element.parents('.alert'),
				messageStackEl = scope.$element.parents('.ul-element-container').prev('.message-stack'),
				successEl = messageStackEl.find('.alert-success');
			
			deffered.done(function(res) {
				if (res.success) {
					if (alertEl.length > 0) {
						alertEl.removeClass('alert-error').addClass('alert-success').text(scope.options.successMsg);
					}
					
					if (messageStackEl.length > 0) {
						successEl.remove();
						messageStackEl.append('<p class="alert alert-success">' + scope.options.successMsg + '</p>');
					}
				}
			});
			
			deffered.always(function() {
				$.publish('hideajaxnotification.sn');
			});
			
			return false;
		});
		
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.ResendConfirmation'),
			options = $.extend({}, ResendConfirmation.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.ResendConfirmation', (data = new ResendConfirmation(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}

	var old = $.fn.resendConfirmation;
	
	$.fn.resendConfirmation = Plugin;
	$.fn.resendConfirmation.Constructor = ResendConfirmation;
	
	$.fn.resendConfirmation.noConflict = function () {
	    $.fn.resendConfirmation = old;
	    return this;
	};
	
	//data-api
	$(function() {
		$('[data-toggle="resend-confirmation"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, document);